module.exports = __webpack_public_path__ + "img/app_5.884daf25.jpg";